import { ElementAttribute } from "../dom-tools/ElementAttribute";
import { RandomUIDGenerator } from "../random/RandomUIDGenerator";
import { SVGEditor } from "../svg/SVGEditor";

export class SVGScaleStyles
{
  static attribute = new ElementAttribute( "scale-styles" );
  static idAttribute = new ElementAttribute( "scale-styles-id" );

  static applyOnDocument()
  {
    SVGScaleStyles.attribute.forEachInDoc( e => this.applyOnElement( e ) );
  }

  static applyOnElement( element:Element )
  {
    let ruleStrings = SVGScaleStyles.attribute.from( element ).split( "," );
    let rules:string[] = [];

    let id = RandomUIDGenerator.createUID();
    let elementID = SVGScaleStyles.idAttribute.selectorEquals( id );
    let svgElement = element as SVGGraphicsElement;
    let box = svgElement.getBBox();

    console.log( "svgscale", ruleStrings, " box", box, ">>", element );

    SVGScaleStyles.idAttribute.to( element, id );

    let regex = /(.*):(\d+(?:\.\d+)?)$/;

    ruleStrings.forEach(
      r =>
      {
        r = r.trim();
        
        let fragments = regex.exec( r );

        console.log( r, ">>", regex, fragments );
        
        if ( fragments === null || fragments.length === 0 )
        {
          return;
        }

        let selector = fragments[ 1 ] || "";
        let scale = parseFloat( fragments[ 2 ] );
        let centerX = box.x + box.width * 0.5;
        let centerY = box.y + box.height * 0.5;
        let newX = centerX * scale;
        let newY = centerY * scale;

        let x = - ( newX - centerX );
        let y = - ( newY - centerY );
        let transformValue = `scale( ${scale}, ${scale} ) translate(${x}px,${y}px )`;
        let idSelector = selector.replace( "$", elementID );

        let rule = `${idSelector}{ transform: ${transformValue}; }`; 

        rules.push( rule );
      }
    );

    let style = document.createElement( "style" );
    let rulesCombined = rules.join( "\n" );
    style.innerHTML = rulesCombined;

    console.log( "SCALE STYLES:", rulesCombined );
    
    element.appendChild( style );
  }
}